import { EMAIL, leadDetailsRightsType } from '../consts';

export const checkEditRight = (
  fieldName: string,
  checkingRights: {} | Record<leadDetailsRightsType, boolean>
): boolean => {
  switch (fieldName) {
    case EMAIL:
      return checkingRights[leadDetailsRightsType.editEmailRights];
    default:
      return checkingRights[leadDetailsRightsType.editDetailsRights];
  }
};
